var styles = {"dot":"InlineLoading-module_dot__h7IDk","up-and-down":"InlineLoading-module_up-and-down__2GSc6"};

export { styles as default };
//# sourceMappingURL=InlineLoading.module.css.js.map
